import { render } from "./ProdutoNovoInicio.vue?vue&type=template&id=60f224b1&scoped=true"
import script from "./ProdutoNovoInicio.vue?vue&type=script&lang=js"
export * from "./ProdutoNovoInicio.vue?vue&type=script&lang=js"

import "./ProdutoNovoInicio.vue?vue&type=style&index=0&id=60f224b1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f224b1"]])

export default __exports__